/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Serve_Ai_Help_DescInputs */

const en_serve_ai_help_desc = /** @type {(inputs: Serve_Ai_Help_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste this into ChatGPT, Claude or Gemini and follow along:`)
};

const id_serve_ai_help_desc = /** @type {(inputs: Serve_Ai_Help_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempel ini ke ChatGPT, Claude, atau Gemini lalu ikuti:`)
};

/**
* | output |
* | --- |
* | "Paste this into ChatGPT, Claude or Gemini and follow along:" |
*
* @param {Serve_Ai_Help_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const serve_ai_help_desc = /** @type {((inputs?: Serve_Ai_Help_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Serve_Ai_Help_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_serve_ai_help_desc(inputs)
	return en_serve_ai_help_desc(inputs)
});